<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.sendUid"
        placeholder="请输入发送者id"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        v-model="params.takeUid"
        placeholder="请输入接收者id"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        placeholder="请选择是否已读消息"
        clearable
        size="small"
        v-model="params.isRead"
        style="width: 180px;"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in isReades"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择消息类型"
        clearable
        size="small"
        v-model="params.msgType"
        style="width: 180px;"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in msgTypes"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sendUid"
        label="发送者id"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sendUid }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="takeUid"
        label="接收者uid"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.takeUid }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="msgType"
        label="消息类型"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.msgType == 'private_letter'">私信消息</span>
          <span v-else-if="scope.row.msgType == 'official_private_letter'">官方私信消息</span>
          <span v-else-if="scope.row.msgType == 'like_msg'">点赞消息</span>
          <span v-else-if="scope.row.msgType == 'follow_msg'">关注消息</span>
          <span v-else-if="scope.row.msgType == 'forward_msg'">转发消息</span>
          <span v-else-if="scope.row.msgType == 'comment_msg'">评论消息</span>
          <span v-else-if="scope.row.msgType == 'like_comment_msg'">点赞评论消息</span>
          <span v-else-if="scope.row.msgType == 'reply_comment_msg'">回复评论消息</span>
          <span v-else-if="scope.row.msgType == 'desire_msg'">心愿工单消息消息</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="消息内容"
        align="center"
        min-width="280"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="imgUrl"
        label="消息图片"
        align="center"
        width="140"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'80px'"
            :src="imgUrl + scope.row.imgUrl"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="sessionId"
        label="会话id"
        align="center"
        min-width="280"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sessionId }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isRead"
        label="消息是否已读"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isRead">已读</el-tag>
          <el-tag type="danger" v-else>未读</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="objId"
        label="帖子id"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.objId }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="objName"
        label="帖子名称"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.objName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        sendUid: undefined, // 发送者uid
        takeUid: undefined, // 接收者uid
        isRead: undefined, // 消息已读or未读
        msgType: undefined, // 消息类型
      },
      msgTypes: [
        {
          label: '私信',
          value: 'private_letter',
        },
        {
          label: '评论',
          value: 'comment_msg',
        },
        {
          label: '点赞',
          value: 'like_msg',
        },
      ],
      isReades: [
        {
          label: '已读',
          value: true,
        },
        {
          label: '未读',
          value: false,
        },
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getChatMessageList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
</style>
